import React, { useRef, useState } from 'react';
import useTranslate from '../../../../common/hooks/useTranslate';

import { IActivityLog } from '../../types/IActivityLog';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import DateCell from '../../../documents/components/cells/dateCell/dateCell';
import ActivityCell from './cells/activityCell/activityCell';
import HeaderCell from '../../../documents/components/cells/headerCell/headerCell';
import TableLoading from '../../../ui/loaders/tableLoader/tableLoading';

import '@progress/kendo-theme-default/dist/all.css';
import './activityLog.scss';

const ActivityLog: React.FC<IActivityLog> = ({activity, loadingActivity}) => {
  const [sort, setSort] = useState<any>([{ field: 'date', dir: 'desc' }]);

  const { t } = useTranslate();
  const tableRef = useRef(null);

  return (
    <div className="table user-activity-wrapper">
      <div className="title-activity-wrapper">
        <span className="card-title">{t('ACTIVITY.LOG_CARD_TITLE')}</span>
      </div>
      <Grid
        data={activity}
        sortable={true}
        sort={sort}
        total={800}
        pageSize={40}
        filterable={true}
        scrollable="scrollable"
        onSortChange={(e) => {
          setSort(e.sort);
        }}
        ref={tableRef}
        selectedField="selected">
        <GridColumn field="name" title={t('ACTIVITY.LOG_COLUMN_NAME')} className="tableCell" headerCell={HeaderCell} />
        <GridColumn
          field="date"
          title={t('ACTIVITY.LOG_COLUMN_WHEN')}
          className="tableCell"
          cell={ActivityCell}
          headerCell={HeaderCell}
          width={200}
        />
        <GridColumn field="date" title={t('ACTIVITY.LOG_COLUMN_DATE')} className="tableCell" cell={(props) => <DateCell {...props} />} width={205} headerCell={HeaderCell} />
      </Grid>
      {loadingActivity && <TableLoading tableElement={tableRef} />}
    </div>
  );
};

export default ActivityLog;
